import React, { Fragment } from "react";

export default function Textarea(props) {
  const { value, required, label, id, name, placeholder, onChange, rows } =
    props;

  return (
    <Fragment>
      <textarea
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        placeholder={placeholder}
        name={name}
        className={"form-control"}
        id={id}
        label={label}
        rows={rows}
      />
    </Fragment>
  );
}
